import * as Module from '../interfaces';
import botbp from '../images/BOTBPoster.png';
import cotbp from '../images/COTB.png';
import potbp from '../images/potb.jpg';
import potbp2 from '../images/potb2.png';
import topop from '../images/topopping.jpeg';
import daven from '../images/dp.png';
import daven2 from '../images/dpnchc.jpg';
import fffp from '../images/Funk_4_Fun.jpg';
import bboogie from '../images/BickfordBoogie.png';
import bboogie2 from '../images/BickfordBoogie2.jpg';
import borderless2 from "../images/bboogie2.jpg";
import dancetogether from '../images/Dance_Together.png';
import unitydpt from '../images/Unity_Davenport.jpg';
import unityprogram from '../images/Unity_Program.jpg';
import unitygroup from '../images/Unity_Group.jpg';
import unity25 from "../images/unity25.jpg";
import fiff_photo from "../images/fiff.png";
import borderless_photo from "../images/borderless.jpg";
import belly_photo from "../images/belly.jpg";
import unity_ojc from "../images/UnityOjc.jpg";
import botsnbolts from "../images/BotsNBolts.jpeg";
import jamnjuice from "../images/JamNJuicePoster_version5.png";
import cities880 from "../images/880-logo-menu-green.png";
import dvplogo from "../images/davenportlogo.png";
import equitas from "../images/equitas_logo.en_.png";
import fam from "../images/family_logo.png";
import occ from "../images/OCC.png";
import parkppl from "../images/Park-People-stack-logo.png";
import redbull from "../images/Red-Bull-logo.png";
import toronto from "../images/Toronto,_City_of.svg.png";
import unity from "../images/unity.png";
import tac from "../images/tornto-arts-council.png";
import evergreen from "../images/evergreen.png";
import buildingTheBoogie from "../images/Building The Boogie.png";
import unity2026 from "../images/UnityOJC2026.png";
import aycsImg from "../images/AYCS.png";
import aycsImg2 from "../images/AYCS2.png";
import * as Util from '../util';
import { MediaType } from '../util';


const bentway = "The Bentway Studio";
const coin8 = "Coin 8 Studio";
const dvpch = "Davenport-Perth Neighbourhood and Community Health Centre";
const bickford = "Bickford Park";
const UNITY_STUDIO = "Unity Charity";
const ASSEMBLY_PARK = "Assembly Park";
const location = {
 BENTWAY : "The Bentway Studio",
 COIN8 : "Coin 8 Studio",
 DVPCH : "Davenport-Perth Neighbourhood and Community Health Centre",
 BICKFORD : "Bickford Park",
 UNITY_STUDIO : "Unity Charity",
 ASSEMBLY_PARK : "Assembly Park",
 TORONTO: "Toronto"
}
export const collaborators = {
  EQUITAS: {
    name: "Equitas",
    image: equitas
  },
  UNITY: {
    name: "Unity Charity",
    image: unity
  },
  WAFF: {
    name: "We Are Family Foundation",
    image: fam
  },
  TAC: {
    name: "Toronto Arts Council",
    image: tac
  },
  REDBULL: {
    name: "Red Bull",
    image: redbull
  },
  DONATIONS: {
    name: "Donations"
  },
  CITIES880: {
    name: "880 Cities",
    image: cities880
  },
  OCC: {
    name: "Ontario Community Changemakers",
    image: occ
  },
  TORONTO: {
    name: "City of Toronto",
    image: toronto
  },
  DVPCH: {
    name: "Davenport-Perth Neighbourhood and Community Health Centre",
    image: dvplogo
  },
  PARKPEOPLE: {
    name: "Park People",
    image: parkppl
  },
  EVERGREEN: {
    name: "Evergreen Brickworks",
    image: evergreen
  }
} 
export function getCollaboratorImageByName(name: string): string | undefined {
  for (const key in collaborators) {
    const collaborator = collaborators[key as keyof typeof collaborators];
    if (collaborator.name === name && 'image' in collaborator) {
      return collaborator.image;
    }
  }
  return undefined; // or fallback image
}
const eventFormat = {
    pop : '1v1 Popping Battle'
}


export const botb: Module.EventProps = {
    name: 'Boogie On The Block',
    about: '1v1 Popping Battle',
    role: 'Organizer',
    date: [new Date(2022, 3, 30)],
    location: location.BENTWAY,
    media: botbp,
    instagram: '/p/CdAZ_6nuVT-/',
    facebook: '970824263797543',
    video: '4Cr8iaauP4U',
    link: 'botb',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.EQUITAS.name, fund: 1150}, {name: collaborators.REDBULL.name, fund: 1485}, {name: collaborators.DONATIONS.name, fund: 535}]
}

export const cotb: Module.EventProps = {
    name: 'Cypher On The Block',
    about: 'Popping Cypher Jam',
    role: 'Organizer',
    date: [new Date(2022, 8, 24)],
    location: bentway,
    media: cotbp,
    instagram: 'p/CjisSNHJ3Mz/',
    facebook: '431711305467858',
    video: 'd2mMJJVw_mk',
    link: 'cotb',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [ {name: collaborators.CITIES880.name, fund: 570}, {name: collaborators.DONATIONS.name, fund: 1250}]
}

export const potb: Module.EventProps = {
    name: 'Party On The Block',
    about: 'Launch party in partnership with various dance collectives',
    role: 'Organizer',
    date: [new Date(2023, 1, 10)],
    location: coin8,
    media: potbp,
    instagram: 'p/Cn4gbq8Lzk6/',
    facebook: '1116902578989034',
    media2: potbp2,
    link: 'cotb',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [ {name: collaborators.CITIES880.name, fund: 1230}, {name: collaborators.OCC.name, fund: 800}, {name: collaborators.DONATIONS.name, fund: 338}]
}

export const topopping: Module.EventProps = {
    name: 'Toronto Popping Battle Series',
    about: '1v1 Popping Battles',
    role: 'Sponsor & Collaborator',
    date: [new Date(2022, 10, 25), new Date(2023, 0, 20), new Date(2023, 2, 17)],
    location: 'Studio North Toronto',
    media: topop,
    instagram: 'p/CkwhtZ-toKU/',
    video: 'yt46sesZX5w',
    link: 'topopping',
    event: MediaType.Series,
    attendees: 60,
    affiliates: [ {name: collaborators.DONATIONS.name, fund: 300}]
}

export const dperth: Module.EventProps = {
    name: 'Street Dance Drop-In Sessions',
    about: 'Weekly Program',
    date: [new Date(2022, 10, 2), new Date(2023, 3, 26)],
    location: dvpch,
    media: daven,
    media2: daven2,
    instagram: 'p/CmZx7VBv3G0/',
    link: 'sessions',
    attendees: 15,
    event: MediaType.Program,
    affiliates: [ {name: collaborators.DVPCH.name, fund: 1250}]
}

export const fff: Module.EventProps = {
    name: 'Funk 4 Fun',
    about: 'Workshops & Battle',
    date: [new Date(2023, 2, 1), new Date(2023, 2, 22)],
    location: dvpch,
    media: fffp,
    instagram: 'p/Co3TsXQt6wn/',
    facebook: '1534855293677206',
    event: MediaType.Festival,
    attendees: 100,
    affiliates: [{name:collaborators.TORONTO.name, fund: 4000}]
}

export const bickfordboogie: Module.EventProps = {
    name: 'Bickford Boogie',
    about: '1v1 Popping Battle',
    date: [new Date(2023, 6, 21)],
    location: bickford,
    media: bboogie,
    media2: bboogie2,
    instagram: 'p/CuXHt1BgBTF/',
    facebook: '966716321244992',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.PARKPEOPLE.name, fund: 750}, {name: collaborators.DONATIONS.name, fund: 250}]

}

export const dancetogetherfest: Module.EventProps = {
    name: 'Dance Together Festivaal',
    about: 'Popping Session',
    date: [new Date(2023, 8 ,30)],
    location: ASSEMBLY_PARK,
    media: dancetogether,
    instagram: 'p/CxoOnWxpoIR/',
    event: MediaType.Normal
}

export const unityfall: Module.EventProps = {
    name: 'Unity Charity Workshops',
    about: 'Weekly Popping Program',
    date: [new Date(2023, 9, 4), new Date(2023, 10, 22)],
    location: UNITY_STUDIO,
    media: unityprogram,
    media2: unitygroup,
    instagram: 'p/CxoIJkXPheY/',
    event: MediaType.Program,
    attendees: 20,
    affiliates: [{name: collaborators.UNITY.name, fund: 1880}]
}

export const unitydavenport: Module.EventProps = {
    name: 'Popping & Street Dance Sessions',
    about: 'Weekly Popping Program with Unity Charity and Davenport',
    date: [new Date(2023, 10, 29), new Date(2024, 2, 27)],
    location: dvpch,
    media: unitydpt,
    instagram: 'p/C0FfzVmvqf1/',
    event: MediaType.Program,
    attendees: 20,
    affiliates: [{name: collaborators.UNITY.name, fund: 1700}]
}

export const fiff: Module.EventProps = {
    name: 'F is for Funk',
    about: '1v1 Open Styles Battle',
    date: [new Date(2024, 1, 17)],
    location: dvpch,
    media: fiff_photo,
    instagram: 'p/C2ILWklAhNA/',
    facebook: '1504067116806534',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.UNITY.name, fund: 3000}]
}

export const borderless: Module.EventProps = {
    name: 'Borderless Boogie',
    about: '1v1 Popping & 1v1 Animation Battles',
    date: [new Date(2024, 7, 10)],
    location: "Evergreen Brick Works",
    media: borderless_photo,
    instagram: 'p/C9X7AQpyDh1/',
    facebook: '8055331731156456',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.EVERGREEN.name, fund: 1000}, {name: collaborators.WAFF.name, fund: 10000}]
}

export const botsnboltsevent: Module.EventProps = {
    name: 'Bots N Bolts',
    about: '1v1 Popping Battle',
    date: [new Date(2024, 9, 4)],
    location: dvpch,
    media: botsnbolts,
    instagram: 'p/C_9DNhrS69U/',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.WAFF.name, fund: 2800}, {name: collaborators.DONATIONS.name, fund: 150}]
}

export const unity2024: Module.EventProps = {
    name: 'Unity Charity Workshops',
    about: 'Weekly Popping Program',
    date: [new Date(2024, 9, 25), new Date(2024, 11, 13)],
    location: UNITY_STUDIO,
    media: unity_ojc,
    instagram: 'p/DAtbqefSo_7/',
    event: MediaType.Program, 
    attendees: 20,
    affiliates: [{name: collaborators.UNITY.name, fund: 1450}]

}

export const unity2025: Module.EventProps = {
    name: 'Street Dance Drop In Sessions',
    about: 'Weekly Street Dance Sessions',
    date: [new Date(2025, 0, 15), new Date(2025, 2, 19)],
    location: dvpch,
    media: unity25,
    instagram: 'p/DEyFuwcSskH/',
    event: MediaType.Program,
    attendees: 20,
    affiliates: [{name: collaborators.UNITY.name, fund: 1260}]
}

export const belly: Module.EventProps = {
    name: 'Belly of the Beatz',
    about: '1v1 Popping Battle',
    date: [new Date(2024, 5, 8)],
    location: "Earl Bales Park",
    media: belly_photo,
    instagram: 'p/C7PoSE6Pjg2/',
    facebook: '7558081957593863',
    event: MediaType.Normal,
    attendees: 150,
    affiliates: [{name:collaborators.TAC.name, fund: 10000}]
}

export const borderlessboogie2: Module.EventProps = {
    name: 'Borderless Boogie 2',
    about: '2v2 Popping Battle',
    date: [new Date(2025, 1, 8)],
    location: dvpch,
    media: borderless2,
    instagram: 'p/DDrsUnExBPe/',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.WAFF.name, fund: 800}]
}

export const jnj: Module.EventProps = {
    name: 'Jam N Juice',
    about: 'Dance Party',
    date: [new Date(2025, 5, 28)],
    location: "District 9",
    media: jamnjuice,
    instagram: 'p/DKcA3gCtxO2/',
    event: MediaType.Normal,
    attendees: 100,
    affiliates: [{name: collaborators.EQUITAS.name, fund: 750}, {name: collaborators.DONATIONS.name, fund: 900}]
}

export const btb: Module.EventProps = {
    name: 'Building the Boogie',
    about: 'Online Conversation',
    date: [new Date(2026, 1, 10)],
    location: "Online",
    media: buildingTheBoogie,
    instagram: 'p/DTBish2Af3J/',
    event: MediaType.Normal,
    attendees: 20
}

export const unityOJC2026: Module.EventProps = {
    name: 'OJC Popping: Train and Gain',
    about: 'Dance Program',
    date: [new Date(2026, 1, 21),new Date(2026, 3, 11)],
    location: UNITY_STUDIO,
    media: unity2026,
    instagram: 'p/DTOWS7Pk-nH/?img_index=1',
    event: MediaType.Program, 
    attendees: 20,
    affiliates: [{name: collaborators.UNITY.name, fund: 1450}]
}

export const aycs: Module.EventProps = {
    name: 'All You Can Street',
    about: 'Cross Collaborative Street Dance Event',
    date: [new Date(2026, 5, 17)],
    location: "Sound Machine 187 Bathurst St",
    media: aycsImg,
    instagram: 'p/DXj2nXFjZoF/',
    event: MediaType.Normal, 
    attendees: 100,
    affiliates: [{name: collaborators.TAC.name, fund: 5000},{name: collaborators.UNITY.name, fund: 1000}]
}

export const aycs2: Module.EventProps = {
    name: 'All You Can Str(eat)',
    about: 'Cross Collaborative Street Dance Event',
    date: [new Date(2026, 7, 26)],
    location: "Carrot Common",
    media: aycsImg2,
    instagram: 'p/DaoOvHoxPkP/',
    event: MediaType.Normal, 
    attendees: 100,
    affiliates: [{name: collaborators.TAC.name, fund: 300}]
}

export const funkforyourfeet: Module.EventProps = {
    name: "Funk For Your Feet",
    about: '1v1 Popping Battle',
    date: [new Date(2009)],
    location: location.TORONTO,
    event: MediaType.Normal,
    affiliates: [{name: "Fantastic Poppers", fund: 0}],
    video: "p_zxh3o1qgw"
}

export const area51: Module.EventProps = {
    name: "Area 51",
    about: '1v1 Popping Battle',
    date: [new Date(2013)],
    location: location.TORONTO,
    event: MediaType.Normal,
    affiliates: [{name: "Moon Runners", fund: 0}],
    video: "sz_0Z6MQw04",
    instagram: "inyourareafest"
}

export const topoppingold: Module.EventProps = {
    name: "TO Popping Battles",
    about: '1v1 Popping Battle',
    date: [new Date(2018)],
    location: location.TORONTO,
    event: MediaType.Normal,
    affiliates: [{name: "5Cent", fund: 0}],
    instagram: "torontopopping"
}

export const event_unsorted: Module.EventProps[] = [
    potb, 
    cotb, 
    dperth, 
    topopping, 
    botb, 
    fff, 
    bickfordboogie, 
    dancetogetherfest, 
    unityfall,
    unitydavenport,
    fiff,
    borderless,
    belly,
    botsnboltsevent,
    unity2024,
    unity2025,
    jnj,
    borderlessboogie2,
    btb,
    unityOJC2026,
    aycs,
    aycs2
];

export const eventlist: Module.EventProps[] = Util.sortEventsByDate(event_unsorted);